import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "What's changing in 2027",
    body: "Under the Victorian Government's Gas Substitution Roadmap, from 2027 a gas hot water system in an existing Victorian home that reaches end of life must be replaced with an efficient electric alternative — such as a heat pump. New homes are already being built all-electric.",
  },
  {
    num: "02",
    title: "What it means for your home",
    body: "Nothing needs to happen today, and no one is removing working systems. But when your gas unit does fail, your replacement options will be electric. Planning ahead lets you choose your timing, your system, and your installer — instead of deciding in an emergency with no hot water.",
  },
  {
    num: "03",
    title: "Why switch on your terms",
    body: "Current Federal and Victorian rebates can take $2,000 or more off the installed cost. Rebates and eligibility rules can change over time — acting while they're available locks in today's incentives.",
  },
];

const Explainer = () => {
  return (
    <section
      data-testid="explainer-section"
      className="bg-[#D8D8D2] py-20 md:py-32"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gdark mb-4 flex items-center gap-2">
            <span className="inline-block w-8 h-px bg-gdark" />
            The facts, plainly
          </p>
          <h2 className="font-serif font-black text-navy tracking-tight text-4xl md:text-5xl lg:text-6xl leading-tight max-w-3xl">
            The 2027 Victorian gas hot water phase-out, explained
          </h2>
        </motion.div>

        <div className="space-y-0">
          {CHAPTERS.map((ch, i) => (
            <motion.article
              key={ch.num}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              data-testid={`explainer-chapter-${ch.num}`}
              className="grid md:grid-cols-[120px_1fr] gap-4 md:gap-10 py-10 border-t border-navy/15 first:border-t-0 first:pt-0"
            >
              <span className="font-serif font-black text-6xl md:text-7xl text-navy leading-none">
                {ch.num}
              </span>
              <div>
                <h3 className="font-serif font-bold text-navy text-3xl md:text-4xl mb-4">
                  {ch.title}
                </h3>
                <p className="text-lg md:text-xl text-navy-muted leading-relaxed max-w-2xl">
                  {ch.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>

        <p
          data-testid="explainer-source-note"
          className="mt-10 text-sm text-navy-muted border-l-2 border-navy pl-4"
        >
          Source: Victorian Government Gas Substitution Roadmap. Rebate amounts
          depend on eligibility and current program settings at the time of
          installation.
        </p>
      </div>
    </section>
  );
};

export default Explainer;
